import React, { Fragment, useContext, useState, useEffect } from 'react';

import { TextArea as TextAreaField } from 'formlabs-web-components/Form';
import { FormContext } from './Form';

const TextArea = ({
  name,
  label,
  isRequired,
  placeholder,
  rows,
  value = '',
  ...props
}) => {
  const { formName, invalidFields } = useContext(FormContext);
  const id = `${formName}_textarea_${name}`;

  const hasError = invalidFields.includes(name);

  return (
    <Fragment>
      {label ? (
        <label aria-hidden="true" htmlFor={id}>
          {label}
        </label>
      ) : null}
      <TextAreaField
        id={id}
        name={name}
        rows={rows}
        wrap="soft"
        required={isRequired}
        placeholder={placeholder}
        hasError={hasError}
        value={value}
        {...props}
      />
    </Fragment>
  );
};

export default TextArea;
